export default {
  hero_title: "Mühelose EU-CBAM-Kohlenstoffcompliance erreichen",
  hero_subtitle:
    "Eine Kohlenstoffberechnungsplattform für KMU, basierend auf EU-offiziellen/benutzerdefinierten Faktoren, zur schnellen Erstellung konformer Berichte.",
  what_is_taxecobit: "Was ist TaxEcoBit?",
  taxecobit_description:
    "TaxEcoBit ist eine Compliance-Automatisierungsplattform, die für Unternehmen entwickelt wurde, die vom EU Carbon Border Adjustment Mechanism (CBAM) betroffen sind. Wir helfen Importeuren, Herstellern und KMU bei der Berechnung von produktspezifischen Kohlenstoffemissionen, der Erstellung CBAM-konformer Berichte und der Reduzierung regulatorischer Risiken.",
  taxecobit_benefits: "Mit TaxEcoBit können Benutzer:",
  benefit_accurate_calculations:
    "Genaue Kohlenstoffberechnungen unter Verwendung offizieller und benutzerdefinierter Emissionsfaktoren durchführen",
  benefit_cbam_documents: "CBAM-konforme Dokumente zur Einreichung generieren",
  benefit_carbon_cost_tracking:
    "Kohlenstoffkostenauswirkungen überwachen und operative Effizienz optimieren",
  benefit_api_integration:
    "Compliance-Workflows nahtlos über API mit ERP- und Lieferketten-Systemen integrieren",
  taxecobit_conclusion:
    "Durch den Ersatz manueller Tabellenkalkulationen und Beraterabhängigkeit ermöglicht TaxEcoBit eine schnellere, zuverlässigere Compliance bei niedrigeren Betriebskosten.",
  register_now: "Jetzt registrieren",
  experience_calculator: "CBAM-Rechner testen",
  try_cbam_calculator: "CBAM-Rechner verwenden",
  download_sample_report: "Beispielbericht herunterladen",
  pdf_report: "PDF-Bericht",
  excel_report: "Excel-Bericht",
  precise: "Präzise",
  precise_description:
    "Basierend auf EU-offiziellen/benutzerdefinierten Faktoren mit einem Berechnungsfehler < 5 %, entsprechend den Compliance-Anforderungen.",
  efficient: "Effizient",
  efficient_description:
    "Unterstützt Batch-Berechnungen, generiert automatisch PDF-/Excel-Berichte mit flexibler Konfiguration.",
  sme_focused: "KMU-fokussiert",
  sme_focused_description:
    "Kein professioneller Hintergrund erforderlich, benutzerfreundliche Oberfläche für schnelle Einarbeitung.",
  api_support: "API-Unterstützung",
  api_support_description:
    "Einfache Integration mit ERP/E-Commerce-Systemen für automatisierte Compliance-Berichterstattung.",
  how_it_works: "So funktioniert's",
};
